import { Dialog, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import type { FilterType, ResultSetMetaData, TripRoute } from '@eti/schema-types';
import FiltersButtons from './FiltersButtons';
import FilterContent from './FilterContent';

const specialDialogFooter = css`
  border-top: 1px solid ${vars.colors.inputs.main};
  flex-direction: column;
  margin-bottom: -16px;
  margin-inline: -16px;
  padding: 16px;

  > button {
    border-radius: ${vars.card.borderRadius};
  }
`;

interface Range {
  max: number;
  min: number;
}

export interface Filters {
  [FilterType.Airlines]?: string[];
  [FilterType.CheckedBaggageIncluded]?: string;
  [FilterType.ExcludeSelfTransfer]?: true;
  [FilterType.MaxStops]?: string;
  [FilterType.Price]?: Range;
  [FilterType.TravelTime]?: number;
  [FilterType.Trip_0ArrivalTime]?: Range;
  [FilterType.Trip_0DepartureTime]?: Range;
  [FilterType.Trip_1ArrivalTime]?: Range;
  [FilterType.Trip_1DepartureTime]?: Range;
  [FilterType.Trip_2ArrivalTime]?: Range;
  [FilterType.Trip_2DepartureTime]?: Range;
  [FilterType.Trip_3ArrivalTime]?: Range;
  [FilterType.Trip_3DepartureTime]?: Range;
  [FilterType.Trip_4ArrivalTime]?: Range;
  [FilterType.Trip_4DepartureTime]?: Range;
}

interface MobileFiltersProps {
  filteredFlightsCount: number;
  isOpen: boolean;
  onClear: () => void;
  onDone: () => void;
  onFilter: (filterOptions: { [key: string]: string[] | null | string }) => void;
  resultSetMetaData: ResultSetMetaData;
  selectedFilters?: Filters;
  searchRoutes: TripRoute[];
}

const MobileFilters = ({
  filteredFlightsCount,
  isOpen,
  onClear,
  onDone,
  onFilter,
  resultSetMetaData: { marketingCarriers, priceRange, travelTimeRange },
  selectedFilters,
  searchRoutes,
}: MobileFiltersProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
      data-testid="resultPage-filtersContainer"
      footer={
        <FiltersButtons
          className={specialDialogFooter}
          filteredFlightsCount={filteredFlightsCount}
          onClear={onClear}
          onDone={onDone}
        />
      }
      isOpen={isOpen}
      onDismiss={onDone}
      title={t('Responsive.Air.Result.Filter.Button.Filter')}
    >
      <FilterContent
        onFilter={onFilter}
        resultSetMetaData={{ marketingCarriers, priceRange, travelTimeRange }}
        searchRoutes={searchRoutes}
        selectedFilters={selectedFilters}
      />
    </Dialog>
  );
};

export default MobileFilters;
